import type { AdminSharedDictionaryRow } from '@/api/generated'

export const EM_DASH = '—'

// This list spans every department, so "Team" alone would not say which one.
export const scopeLabel = (item: AdminSharedDictionaryRow) =>
  item.team_id ? (item.team_name ?? 'Team') : 'Organization'

// Absolute: both existing relative-time helpers take other input shapes.
export const formatIsoDate = (value: string | null | undefined) =>
  value
    ? new Date(value).toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      })
    : EM_DASH
